<template>
  <div class="props-form">
      <!--HASHING-->
      <div v-if="isHashing">
        <p>Calculating SHA256 Digest for file:</p>
        <p><strong>{{ fileName }}</strong></p>
        <p>Progress: <strong>{{ currentProgress }}%</strong></p>
      </div>
      <!--SUCCESS-->
      <div v-if="isHashed">
        <h2>{{ fileName }}</h2>
        <form>
          <div v-for="item in uploadedFiles" v-bind:key="item.originalName" class="form-group">
            <label for="sha256">SHA256</label>
            <input type="text" class="form-control" id="sha256" aria-describedby="sha256Help" placeholder="sha256 checksum" :value="item.sha256" disabled>
          </div>
          <div class="form-group">
            <label for="inputDescription">Description</label>
            <limit-text-input id="inputDescription"
              placeholder="Enter media description text"
              multiline
              :limitLow="0" :limitHigh="maxDescriptionLength"
              :cols="40" :rows="5"
              v-model="description"
              ></limit-text-input>
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-primary submit" :disabled="!validateForm" @click.prevent="checkContractArgs">Next&nbsp;&gt;&gt;&gt;</button>
          </div>
        </form>
      </div>
      <!--FAILED-->
      <div v-if="isFailed">
        <h2>Hashing failed</h2>
      </div>
  </div>
</template>

<script>
  import Vue               from 'vue'
  import { mapActions
         , mapGetters
         , mapState      } from 'vuex'
  import LimitTextInput    from './LimitTextInput'

  export default {
    name: "PropsForm"
  , props: {
      maxDescriptionLength: { type: Number, default: 2048 }
    }
  , data () {
      return {
        fileCount: 0
      , description: null
      }
    }
  , components: { LimitTextInput }
  , computed: {
      ...mapGetters(['isHashing', 'isHashed', 'isFailed', 'isPrepared'])
    , ...mapState(['uploadedFiles', 'currentProgress'])
    , fileName() { return this.uploadedFiles[0] ? this.uploadedFiles[0].originalName : null }
    }
  , methods: {
    ...mapActions(['prepareToCast'])
    , checkContractArgs (e) {
        // console.log(e)
        this.validateForm() &&
        this.prepareToCast({ description: this.description })
        .then(
          result => this.$router.push({ name: 'Cast' })
        , error => console.error(error)
        )
      }
    , validateForm() {
        return null != this.description
              && 0 < this.description.length
              && this.description.length <= this.maxDescriptionLength
      }
    }
  , mounted() {
      if (0 == this.uploadedFiles.length) {
        this.$router.push({ name: 'Dropzone' })
      } else if ( this.isPrepared ) {
        this.$router.push({ name: 'Cast' })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .form-group {
    width: 60%;
    margin-left: 20%;
    margin-right: 20%;
    text-align: left;
    .submit {
      width: 100%;
      color: #fff;
      background-color: #000000;
      border-color: #000000;
    }
  }
  .form-control {
    width: 100%;
  }
  /deep/ #inputDescription {
    font-family: monospace;
  }
</style>



// WEBPACK FOOTER //
// src/components/caster/PropsForm.vue